import { ApiResponse } from '@nohara-dxdev/oidc-core';
import { QueryConfig } from '@nohara-dxdev/react-core';
import { useScopeIds } from '@nohara-dxdev/react-oidc';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { ProjectEntity } from '@/types/api';

export const getProject = async (orgId: string, projectId: string): Promise<ProjectEntity> => {
  const { data } = await api.get<any, ApiResponse<ProjectEntity>>(
    `/orgs/${orgId}/projects/${projectId}`,
  );
  return data;
};

export const getProjectQueryKey = (orgId?: string | null, projectId?: string | null) => {
  const queryKey = ['project'];
  if (orgId) queryKey.push(orgId);
  if (projectId) queryKey.push(projectId);
  return queryKey;
};

export const getProjectQueryOptions = (
  orgId: string | undefined | null,
  projectId: string | undefined | null,
) => {
  return queryOptions({
    queryKey: getProjectQueryKey(orgId, projectId),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => getProject(orgId!, projectId!),
    enabled: !!orgId && !!projectId,
  });
};

interface UseProjectOptions {
  queryConfig?: QueryConfig<typeof getProjectQueryOptions>;
}

export const useProject = (
  projectId: string | undefined,
  { queryConfig }: UseProjectOptions = {},
) => {
  const { orgId } = useScopeIds();
  return useQuery({
    ...getProjectQueryOptions(orgId, projectId),
    ...queryConfig,
  });
};
